import ENVIRONMENT_VAR from "../model/const/env/env.const";

export const isProduction = () => {
  return ENVIRONMENT_VAR.NODE_ENV === "prod";
};
export const isStage = () => {
  return ENVIRONMENT_VAR.NODE_ENV === "stage";
};

export const isLocalHost = () => {
  return ENVIRONMENT_VAR.NODE_ENV === "localhost";
};
